<template>
  <chart-shell :title="title" :info="chartConfig.info">
    <div>
      <div class="area-chart" :id="title" :style="{ height: `${height}px` }"></div>
    </div>
  </chart-shell>
</template>

<script>
import ChartShell from "@c/m11b-report-detail/sleep-chart/chart-shell.vue";
import { DateTool } from "@js/date-tool.js";
import { Area } from "@antv/g2plot";

export default {
  components: {
    ChartShell,
  },

  props: {
    title: String,
    dataArray: Array,
    timeTickArray: Array,
    sn: String,
    height: {
      type: Number,
      default: 190,
    },
  },

  data() {
    return {
      chartConfig: {
        info: "",
        yMin: 0,
        yMax: 0,
        yTickCount: 0,
        tooltipTitle: "",
        tooltipUnit: "",
      },
      areaChart: null, // 存储图表实例
    };
  },

  mounted() {
    if (this.dataArray && this.dataArray.length > 0) {
      this.configureChart();
    }

  },

  watch: {
    dataArray: {
      handler(newData) {
        if (newData && newData.length > 0) {
          this.$nextTick(() => {
            this.configureChart();
          });
        }
      },
      immediate: true
    }
  },

  beforeDestroy() {
    // 组件销毁前清理图表实例
    if (this.areaChart) {
      this.areaChart.destroy();
      this.areaChart = null;
    }
  },

  methods: {
    sampleData(dataArray, interval = 4) {
      // 如果数据量小于10000，不需要采样
      if (!dataArray || dataArray.length <= 10000) {
        return dataArray;
      }

      const sampledData = [];
      // 采样第一个数据点
      if (dataArray.length > 0) {
        sampledData.push(dataArray[0]);
      }

      // 从第interval+1个数据开始，每隔interval取一个数据点
      for (let i = interval + 1; i < dataArray.length; i += interval + 1) {
        sampledData.push(dataArray[i]);
      }

      // 确保包含最后一个数据点
      if (dataArray.length > 1 && sampledData[sampledData.length - 1] !== dataArray[dataArray.length - 1]) {
        sampledData.push(dataArray[dataArray.length - 1]);
      }

      return sampledData;
    },

    configureChart() {
      // 如果没有数据，不渲染图表
      if (!this.dataArray || this.dataArray.length === 0) {
        return;
      }


      switch (this.title) {

        case "睡眠体动占比":
          this.chartConfig = {
            info: "体动占比",
            yMin: 0,
            yMax: 60,
            yTickCount: 5,
            tooltipTitle: "时长",
            tooltipUnit: "秒",
          };
          break;
        case "体动图":
          this.chartConfig = {
            info: "体动幅度",
            // yMin: 0,
            // yMax: 0.3,
            // yTickCount: 1,
            tooltipTitle: "",
            tooltipUnit: "",
          };
          break;
        default:
          break;
      }
      this.renderChart();
    },

    renderChart() {
      // 如果已存在图表实例，先销毁
      if (this.areaChart) {
        this.areaChart.destroy();
        this.areaChart = null;
      }

      // 确保容器存在
      const container = document.getElementById(this.title);
      if (!container) {

        return;
      }

      // 清空容器内容
      container.innerHTML = '';

      // 如果数据为空，使用空数组，否则使用采样后的数据
      const chartData = this.dataArray && this.dataArray.length > 0 ? this.sampleData(this.dataArray) : [];

      this.areaChart = new Area(this.title, {
        data: chartData,
        xField: "xValue",
        yField: "yValue",
         // 性能优化配置
        animation: this.title === "体动图" ? false : true, // 体动图关闭动画
        renderer: 'canvas', // 使用canvas渲染器提高性能
        meta: {
          xValue: {
            type: "time",
            mask: "HH:mm",
            tickMethod: () => {
              return this.timeTickArray;
            },
          },
        },
        xAxis: {
          line: {
            style: {
              stroke: "#333",
            },
          },
          tickLine: {
            style: {
              stroke: "#333",
            },
          },
        },
        yAxis: {
          min: this.chartConfig.yMin,
          max: this.chartConfig.yMax,
          tickCount: this.chartConfig.yTickCount,
          grid: null,
          line: {
            style: {
              stroke: "#333",
            },
          },
          tickLine: {
            style: {
              stroke: "#333",
            },
          },
        },
        areaStyle: () => {
          return {
            fill: this.title === "体动图" ? "#1890ff" : "#de2146",
            fillOpacity: 1,
          };
        },
        line: {
          size: 0.1,
        },
        tooltip: this.title === "体动图" ? false : {
          showTitle: this.title != "睡眠体动幅度",
          formatter: (item) => {
            switch (this.title) {
              case "睡眠体动幅度":
                return {
                  name: DateTool.millisecondTimestampToStr(item.xValue, "h:m"),
                  value: item.yValue,
                };
              default:
                break;
            }
          },
        },
      });
      this.areaChart.render();


    },
  },
};
</script>

<style lang="scss" scoped>
.area-chart {
  width: 100%;
  box-sizing: border-box;
  padding: 0 rem(25);
  margin-top: rem(10);
  margin-bottom: rem(10);
}
</style>
